export default __webpack_public_path__ + "static/media/manFloating.ceed0cbe.png";